// Static content for all editorial pages. Kept here for easy editing.

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/temple", label: "Temple", testId: "nav-temple" },
  { to: "/ratha-yatra", label: "Ratha Yatra", testId: "nav-ratha" },
  { to: "/gita-govinda", label: "Gita Govinda", testId: "nav-gita" },
  { to: "/jagannathastakam", label: "Ashtakam", testId: "nav-ashtakam" },
  { to: "/gaudiya", label: "Gaudiya", testId: "nav-gaudiya" },
  { to: "/vedanta", label: "Sampradaya", testId: "nav-vedanta" },
  { to: "/acharyas", label: "Acharyas", testId: "nav-acharyas" },
  { to: "/nityanushtanam", label: "Nityanushtanam", testId: "nav-nitya" },
  { to: "/gallery", label: "Gallery", testId: "nav-gallery" },
  { to: "/marketplace", label: "Marketplace", testId: "nav-marketplace" },
  { to: "/payment", label: "Payment", testId: "nav-payment" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export const HERO_LINES = [
  "Jai",
  "Śrī Jagannātha",
  "of Nīlācala.",
];

export const HERO_SUB =
  "A living archive of Sanātana Dharma — the temple of Puri, the songs of Jayadeva, the philosophies of the ācāryas, and a handbook for the daily life of a Vaiṣṇava.";

export const MARQUEE_TEXT =
  "जगन्नाथः स्वामी नयनपथगामी भवतु मे  ·  Jai Jagannātha  ·  Jai Baladeva  ·  Jai Subhadrā  ·  नीलाचल निवासिने  ·  Ratha Yātrā  ·  Gīta Govinda  ·  Nityānusthānam  ·  ";

export const CHAPTERS = [
  {
    num: "01",
    kicker: "The Trust",
    title: "A vow to preserve, to teach, to serve.",
    body:
      "Shri Puri Jagannath Religious and Charitable Trust exists to keep the fire of Sanātana Dharma alive — through study, ritual, feeding, and the patient work of remembering.",
  },
  {
    num: "02",
    kicker: "The Lord",
    title: "Śrī Jagannātha, Balabhadra, Subhadrā.",
    body:
      "On the sea-blue hill of Nīlācala, three deities of wood are worshipped by kings and mendicants alike. Their sanctum is older than empires; their darśana is offered to everyone.",
  },
  {
    num: "03",
    kicker: "The Poets",
    title: "From Jayadeva's Gīta Govinda to Śaṅkara's Ashṭakam.",
    body:
      "The temple's history is a history of poetry. Jayadeva wrote love-songs the Lord Himself is said to have edited; Ādi Śaṅkara composed eight verses now sung in every corridor.",
  },
  {
    num: "04",
    kicker: "The Bhaktas",
    title: "Caitanya, Nityānanda, and the Gauḍīya lineage.",
    body:
      "Śrī Caitanya Mahāprabhu spent the last eighteen years of his life in Purī, in constant sight of Jagannātha. From him flows a river of bhakti — Rūpa, Sanātana, and the Six Goswāmis of Vṛndāvana.",
  },
  {
    num: "05",
    kicker: "The Acharyas",
    title: "Rāmānuja, Vedānta Deśika, the twelve Āzhvārs.",
    body:
      "The Śrī Vaiṣṇava tradition offers the philosophy of Viśiṣṭādvaita, the songs of the Āzhvārs, and a complete science of temple worship — Pāñcarātra and Vaikhānasa.",
  },
  {
    num: "06",
    kicker: "The Daily Rite",
    title: "A handbook for the householder Vaiṣṇava.",
    body:
      "Sandhyāvandanam, Yajñopavīta Dhāraṇam, Tarpaṇam, Śrāddham — the small rituals that quietly shape a life. We provide the mantras and the method.",
  },
];
